<div *ngIf="errors">
    <div *ngFor="let e of errors | keyvalue">
      <div [ngSwitch]="e.key">
        <small *ngSwitchCase="'required'" class="form-danger">Campo obbligatorio</small>
        <small *ngSwitchCase="'email'" class="form-danger">Inserire un indirizzo email valido</small>
        <small *ngSwitchCase="'pattern'" class="form-danger">La password deve contenere almeno 8 caratteri, un carattere maiuscolo, un carattere minuscolo, un numero, ed un carattere speciale.</small>
        <small *ngSwitchDefault class="form-danger">{{ e.value }}</small>
      </div>
    </div>
  </div>
